// Vuex module skeleton cho module Dịch vụ bảo hành (t101020).
// State + actions + mutations sẽ build dần từ M4 (RepairSlip CRUD).
// Hiện tại chỉ giữ state mặc định để store đăng ký được.

const mutations = {
    SET_CURRENT_SLIP: 'SET_CURRENT_SLIP',
    RESET_CURRENT_SLIP: 'RESET_CURRENT_SLIP',
};

const initialState = {
    currentSlip: null,
};

export default {
    state: { ...initialState },
    getters: {
        getCurrentRepairSlip(state) {
            return state.currentSlip;
        },
    },
    actions: {
        setCurrentRepairSlip({ commit }, payload) {
            commit(mutations.SET_CURRENT_SLIP, payload);
        },
        resetCurrentRepairSlip({ commit }) {
            commit(mutations.RESET_CURRENT_SLIP);
        },
    },
    mutations: {
        [mutations.SET_CURRENT_SLIP](state, payload) {
            state.currentSlip = payload;
        },
        [mutations.RESET_CURRENT_SLIP](state) {
            state.currentSlip = null;
        },
    },
};
